(function() {
    if (typeof window.CustomEvent === 'function') return false;
    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();


const $51d44e8b27788f1a$var$reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const $51d44e8b27788f1a$var$isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
const $51d44e8b27788f1a$var$concat = Function.bind.call(Function.call, Array.prototype.concat);
const $51d44e8b27788f1a$var$keys = Reflect.ownKeys;
if (!Object.values) Object.values = function values(O) {
    return $51d44e8b27788f1a$var$reduce($51d44e8b27788f1a$var$keys(O), (v, k)=>$51d44e8b27788f1a$var$concat(v, typeof k === 'string' && $51d44e8b27788f1a$var$isEnumerable(O, k) ? [
            O[k]
        ] : []), []);
};
if (!Object.entries) Object.entries = function entries(O) {
    return $51d44e8b27788f1a$var$reduce($51d44e8b27788f1a$var$keys(O), (e, k)=>$51d44e8b27788f1a$var$concat(e, typeof k === 'string' && $51d44e8b27788f1a$var$isEnumerable(O, k) ? [
            [
                k,
                O[k]
            ]
        ] : []), []);
};


'use strict';


//# sourceMappingURL=project.c328e36e.js.map
